import React, { useCallback, useState} from 'react';
import { Form, Input, Button } from 'antd';
import { expressDescSteps } from './enums.js';
import { returnExpressMaterialCheck } from '../../../../service/expressMaterial';

export default function CheckForm(props) {
  const [loading, setLoading] = useState(false);

  // 提交不合格结论
  const onSubmitRejectCheck = useCallback(async (values) => {
    setLoading(true);
    try {
      const { result } = await returnExpressMaterialCheck(props.flowId, {
        content: expressDescSteps.checkAgent,
        ...values
      })
      props.onSuccess && props.onSuccess(result);
    } catch { }
    setLoading(false);
  }, [props])

  const onCancel = useCallback(() => props.onCancel && props.onCancel(), [props]);

  return <React.Fragment>
    <p className="margin-bottom">材料不合格，需退回经办联系客户补传</p>
    <Form onFinish={onSubmitRejectCheck}>
      <Form.Item label="退回原因" name="reason" rules={[{ required: true, message: '请输入退回原因' }]}>
        <Input.TextArea maxLength={500} placeholder="请输入描述说明, 500字内" style={{ height: 80 }} />
      </Form.Item>
      <Form.Item className="align-right" style={{ marginBottom: 0 }}>
        <Button className="margin-right" onClick={onCancel}>取消</Button>
        <Button type="primary" htmlType="submit" loading={loading}>确定</Button>
      </Form.Item>
    </Form>
  </React.Fragment>
}